module.exports = __webpack_public_path__ + "img/logo2.28015955.png";